import { HomeComponent } from './../home/home.component';
import { Router } from '@angular/router';
import { Component } from '@angular/core';
import { MatDialog } from '@angular/material';
declare const swal: any;
@Component({
  selector: "page-auxTotem",
  templateUrl: "auxTotem.component.html",
  styleUrls: ["./auxTotem.component.css"]
})

export class AuxTotemComponent {
  constructor(private dialog: MatDialog, private _router: Router) {

  }
  sign(tipo) {
    //  alert(tipo);
    if (sessionStorage.getItem("identity-domCloud") && sessionStorage.getItem("token-domCloud")) {
      this.dialog.closeAll();
      if (tipo == 'totem-busqueda-direccion') {

        this._router.navigate([`/totem-busqueda-direccion`]);
      } 
    } else {
      if (tipo == 'totem-busqueda-direccion') {
        //console.log("expediente 2");
        this._router.navigate([`/totem-busqueda-direccion`]);
      } 
      
    }
    this.dialog.closeAll()
  }

}
